const sheetSizeSolver = (v, data) => data.get('sheetHeight') ?
  ([
    data.get('sheetHeight'),
    data.get('sheetWidth'),
    data.get('sheetDepth'),
  ].filter(v => v).join(' x ') + ' ' + (data.get('sheetUnit') || '').toLowerCase()) :
  null;

export default sheetSizeSolver;
